import {SelectContentHandleClick} from 'helpers-ga4';

document.addEventListener('DOMContentLoaded', () => {
  const selectContentLinks = `.section-image-banner [data-ga4-event-type="select_content"]`;

  document.querySelectorAll(selectContentLinks).forEach(link => {
    link.addEventListener('click', SelectContentHandleClick);
  });
});